export const occupantsRequired = {
    "Rainwater Tank - Above Slab": true,
    "Rainwater Tank - Buried": true,
    "Waterline Rainwater Tank": true,
};
